"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABS_APPEARANCES = void 0;
var TABS_APPEARANCES = Object.freeze({
  default: 'default',
  file: 'file'
});
exports.TABS_APPEARANCES = TABS_APPEARANCES;